export const InstallationStatuses = {
  NotInstalled: 'NOT_INSTALLED',
  SuccessfulInstallation: 'SUCCESSFUL_INSTALLATION',
  IssueWithInstallation: 'ISSUE_WITH_INSTALLATION',
  NoStatus: 'NO_STATUS',
};
